export const AuthValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.UserName.trim()) {
      errors.UserName = 'Please enter User Name';
    }
  
    if (!formData.Password.trim()) {
      errors.Password = 'Please enter password';
    }
   // Add more validations as needed for other fields
  
    return errors;
  };
  
  